import Vue from 'vue'
import CodefabrikUi from '@codefabrik/ui-vue'

Vue.use(CodefabrikUi)
